import { PayPaymentsMapperParams } from "@/models/payment/interfaces/payment";
import { PayPaymentsDTO } from "@appetize/iw-common/interfaces/freedomPay/IpayPayments";
import { APPLICATION_NAME } from "@/../app-constants";

export const mapFPRequest = (params: PayPaymentsMapperParams): PayPaymentsDTO => {
  return {
    session_key: params.sessionKey,
    freedom_pay: {
      terminal_id: params.terminalId,
      payment_key: params.paymentKey,
      token_information: {
        expiration_month: params.expDateMonth,
        expiration_year: params.expDateYear,
        token: params.tokenCard,
      },
      token_create_service: params.saveCardToken ? {
        run: params.saveCardToken,
        type: 10
      } : undefined,
      card: {
        name_on_card: params.nameOnCard
      },
      purchase_totals: {
        charge_amount: params.amount,
        tax_total: params.tax
      },
      invoice_header: {
        purchaser_code: params.invoiceNumber
      },
      pos: {
        card_present: params?.pos?.cardPresent || "",
        entry_mode: params?.pos?.entryMode || "",
        enc_mode: params?.pos?.encMode || "",
        msr_type: params?.pos?.msrType || "",
        tracke: params?.pos?.tracke || {}
      },
      client_meta_data: {
        application_name: APPLICATION_NAME,
        application_version: params?.releaseVersion,
        selling_middleware_name: "",
        selling_middleware_version: "",
      },
      items: [
        {
          product_sku: "10-101",
          product_name: "food and beverage",
          product_description: "food and beverage",
          unit_price: params.amount,
          quantity: 1,
          total_amount: params.amount,
          tax_included_flag: "Y",
          tax_amount: params.tax,
          unit_of_measure: "",
          sale_code: "S"
        }
      ]
    }
  };
};
